// "Tamanho do texto" (0.67): o código fica em lib/rn/texto.tsx (sozinho na pasta, ver o comentário lá).
export { definirEscalaTexto, escalaTexto } from './rn/texto';
